<script lang="ts">

    import {
        discountToTwoDecimalPlaces,
        totalAccessoriesPriceToTwoDecimalPlaces,
    } from "./stores";
    import DetailedTotalFinalRow from "./DetailedTotalFinalRow.svelte";
    import ValetPriceRow from "./ValetPriceRow.svelte";
    import DiscountRow from "./DiscountRow.svelte";
    import AccessoriesPriceRow from "./AccessoriesPriceRow.svelte";
    import SubtotalRow from "./SubtotalRow.svelte";
</script>

<table class="mx-auto mb-2">
    {#if $totalAccessoriesPriceToTwoDecimalPlaces === 0 && $discountToTwoDecimalPlaces === 0}
        <DetailedTotalFinalRow/>
    {:else if $totalAccessoriesPriceToTwoDecimalPlaces === 0 && $discountToTwoDecimalPlaces > 0}
        <ValetPriceRow/>
        <DiscountRow/>
        <DetailedTotalFinalRow/>
    {:else if $totalAccessoriesPriceToTwoDecimalPlaces > 0 && $discountToTwoDecimalPlaces === 0}
        <ValetPriceRow/>
        <AccessoriesPriceRow/>
        <DetailedTotalFinalRow/>

    {:else if $totalAccessoriesPriceToTwoDecimalPlaces > 0 && $discountToTwoDecimalPlaces > 0}
        <ValetPriceRow/>
        <AccessoriesPriceRow/>
        <SubtotalRow/>
        <DiscountRow/>
        <DetailedTotalFinalRow/>
    {/if}
</table>
